// Pestaña «Reportes generales» de /products-list (?tab=...), para volver a ella al salir de un reporte
export const PRODUCTS_LIST_REPORTS_TAB = 'reportes'
